export default "__VITE_ASSET__C4jbq_8D__"